import { useCallback, useContext, useEffect, useState } from "react"

// Context
import { UserContext } from "../../../../context/userContext"
import { FirebaseContext } from "../../../../firebase"

//formik
import { useField } from "formik"

//graphQL
import { useLazyQuery } from "@apollo/client"
import { GET_ORGANIZATION } from "../../queries"

//PrimeReact
import { Slider } from "primereact/slider"
import { Tooltip } from "primereact/tooltip"

//SOAR Components
import { LogError } from "../../../../helpers/logger"
import { LoaderSmall } from "../../../../components/Loaders"
import defaultLogo from "../../../../assets/images/default-logo2.jpg"

//styles
import kioskStyles from "../../../../styles/kiosk/KioskAdmin.module.css"
import myStyles from "../../../../styles/kiosk/KioskAdminOrganization.module.css"

export default function KioskAdminOrganizationLogo({
  organization_id,
  disabled,
}) {
  const userCtx = useContext(UserContext)
  const firebase = useContext(FirebaseContext)

  const [logoSizeField, , logoSizeHelpers] = useField("logoSize")

  const { getStorage, ref, getDownloadURL } = firebase.storage
  const storage = getStorage()

  const [isLoading, setIsLoading] = useState(true)
  const [logoUrl, setLogoUrl] = useState(undefined)

  const [getOrganization] = useLazyQuery(GET_ORGANIZATION, {
    fetchPolicy: "cache-and-network",
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: organization_id,
    },
  })

  const getOrganizationLogo = useCallback(async () => {
    try {
      if (organization_id) {
        setIsLoading(true)

        const organization = await getOrganization({
          variables: {
            staff_id: userCtx.session.user.staff_id,
            organization_id: organization_id,
          },
        })
        if (organization?.data?.organization) {
          if (organization?.data?.organization?.organization_logo) {
            const logoRef = ref(
              storage,
              organization?.data?.organization.organization_logo
            )
            const downloadUrl = await getDownloadURL(logoRef)
            setLogoUrl(downloadUrl)
          } else {
            setLogoUrl(undefined)
          }
        } else {
          LogError("Unable to load organization logo", organization)
          setLogoUrl(undefined)
        }

        setIsLoading(false)
      } else {
        setLogoUrl(undefined)
        setIsLoading(false)
      }
    } catch (error) {
      LogError("Unable to load organization logo", error)
      userCtx.setNotificationError("Unable to load organization logo")
      setLogoUrl(undefined)
      setIsLoading(false)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization_id])

  useEffect(() => {
    getOrganizationLogo()
  }, [getOrganizationLogo])

  const handleLogoHeight = () => {
    //return Math.min(logoSizeField.value, 120)
    return logoSizeField.value
  }
  return (
    <div className={`${kioskStyles.container} ${kioskStyles.fullHeight}`}>
      <div className={myStyles.logoLayout}>
        <div className={myStyles.logoLayoutLabel}>
          <label>Organization logo size</label>
          <small style={{ color: "gray", display: "block" }}>
            {`Drag the slider below the image to set the desired height of the logo to be displayed in the Kiosk UI`}
          </small>
        </div>
        <div className={myStyles.logoLayoutLogo}>
          <div className={myStyles.logoContainer}>
            {isLoading ? (
              <LoaderSmall />
            ) : (
              <img
                src={logoUrl || defaultLogo}
                alt=""
                style={{
                  width: "auto",
                  height: `${handleLogoHeight()}px`,
                }}
              />
            )}
          </div>
        </div>
        <div className={myStyles.logoLayoutControl}>
          <Tooltip
            target=".p-slider-handle"
            content={`${logoSizeField.value}`}
            position="bottom"
          />
          <div className={myStyles.logoSliderLabel}>
            <label>Current height: {logoSizeField.value}px</label>
          </div>

          <Slider
            min={80}
            max={300}
            value={logoSizeField.value || 150}
            onChange={(e) => {
              logoSizeHelpers.setValue(e.value)
            }}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  )
}
